import {
  useGetEditRecurringJobs,
  useUpdateRecurringJob,
} from "@/modules/routes/recurring-jobs-routes";
import { useMemo } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import * as yup from "yup";
import polyglot from "@/utils/polyglot";
import EditFrequencySelection from "../EditFrequencySelection";
import Layout from "../Layout";
import PricePerHourSelection from "../PricePerHourSelection";
import TimeHoursSelection from "../TimeHourSelection";

const RecurringJobsEdit = () => {
  const { id } = useParams();
  const updateRecurringJob = useUpdateRecurringJob(id);
  const { data, isLoading } = useGetEditRecurringJobs(id);

  const handleSubmit = (values) => {
    updateRecurringJob.mutate(values);
  };

  const pages = useMemo(
    () => [
      {
        path: "frequency",
        title: polyglot.t("recurring.frequency"),
        View: EditFrequencySelection,
        validationSchema: yup.object().shape({
          frequency: yup.string().required(),
          wday: yup.string().required(),
          wposition: yup.number(),
        }),
      },
      {
        path: "time-hour",
        title: polyglot.t("recurring.select_time_hour"),
        View: TimeHoursSelection,
        validationSchema: yup.object().shape({
          start_hour: yup.number().required(),
          nb_hours: yup
            .number()
            .min(1, polyglot.t("categories.minimal_duration_error"))
            .required(),
        }),
      },
      {
        path: "price-per-hour",
        title: polyglot.t("recurring.select_price_per_hour"),
        View: PricePerHourSelection,
        customProps: {
          data,
        },
        validationSchema: yup.object().shape({
          price_per_hour: yup.number().required(),
        }),
      },
    ],
    [data]
  );

  return (
    <Layout
      data={data}
      pages={isLoading ? [] : pages}
      onSubmit={handleSubmit}
      initialValues={{
        ...data,
        private_jobber_id: data?.jobber?.id,
        end_hour:
          data?.start_hour && data?.nb_hours
            ? data?.start_hour + data?.nb_hours
            : undefined,
      }}
      isLoading={updateRecurringJob.isLoading || updateRecurringJob.isSuccess}
    />
  );
};

export default RecurringJobsEdit;
